import config from "../../config";
import Moment from "moment";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css";
import Pagination from "../../components/Pagination";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import deleteIcon from "../../images/icons/delete.png";
import viewIcon from "../../images/icons/view.png";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Swal from "sweetalert2";
import filter from "../../images/icons/filter.png";
import DateRangeFilter from "../../components/DateRangeFilter";
import { millionComma } from "../../utils";
import moment from "moment";
import editIcon from "../../images/icons/edit.png";
import { formatStatusBadge } from "../Purchase/util";
import { ConfigContext } from "../../App";
import { FcApproval } from "react-icons/fc";
import { FaInfoCircle } from "react-icons/fa";

function PurchaseReturnList(props) {
  const location = useLocation();

  const initialState = {
    is_active: "",
    po_no: "",
    po_rtn_no: "",
    po_id: "",
    po_rtn_id: "",
    from_date: "",
    to_date: "",
    branch_id: "",
    sync_status: "",
  };

  const [user, setUser] = useState({});

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  let newFilter = location.state?.appliedFilter || initialState;
  let newFilterVisiblity = location.state?.filterDisplay;
  const loginBranch = useContext(ConfigContext)?.loginBranch;
  const erpIntegration = useContext(ConfigContext)?.erpIntegration;
  const [isErpLoading, setIsErpLoading] = useState(false);
  let backToCurrPage = location.state?.backToCurrent;

  const [formInputs, setFormInputs] = useState(newFilter);
  const [filtersVisible, setFiltersVisible] = useState(
    newFilterVisiblity === true ? true : false,
  );
  const [filterActive, setFilterActive] = useState(
    location.state?.appliedFilter ? true : false,
  );
  const [isSubmit, setIsSubmit] = useState(false);
  const [excelData, setExcelData] = useState([]);

  const [list, setList] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    backToCurrPage ? backToCurrPage : 1,
  );
  const [totalPage, setTotalPage] = useState(0);
  const [filterDate, setFilterDate] = useState();
  let dates = filterDate && JSON.parse(filterDate.date);

  function handleInputDate(e) {
    setFilterDate((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  }

  // const displayList = list.slice(currentPage * 10 - 10, currentPage * 10);

  function toggleItemDetail(id) {
    $(`#${id}`).is(":visible")
      ? $(`#${id}`).addClass("d-none")
      : $(`#${id}`).removeClass("d-none");
  }

  function changeStatus(po_rtn_id, branch_id) {
    confirmAlert({
      title: "Are you sure?",
      message: "You want to cancel purchase return.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            $.post(
              `${config.apiUrl}/purchaseOrderReturn/cancelPurchaseOrderReturn`,
              JSON.stringify({
                po_rtn_id: po_rtn_id,
                branch_id: branch_id,
              }),
            )
              .done(function (res) {
                setError("");
                setSuccess(res.message);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setError(
                  err?.responseJSON?.data?.message ||
                    err?.responseJSON?.message,
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              })
              .always(function () {
                getList(filtersVisible);
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  }
  function ApprovedBranch(po_rtn_id) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;

    confirmAlert({
      title: "Are you sure?",
      message: `You want to approve purchase Return`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            $.post(
              `${config.apiUrl}/purchaseOrderReturn/manualAutoApprove`,
              JSON.stringify({ po_rtn_id: po_rtn_id }),
            )
              .done(function (res) {
                getList(filtersVisible);
                setError("");
                console.log("sjgsdshdjsjdks", res?.data);
                setSuccess(res?.data);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setSuccess("");
                setError(
                  err?.responseJSON?.data?.message ||
                    err?.responseJSON?.message,
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  async function getList(isFilter = true, pageNo = null) {
    let json = {
      paginate: 1,
      page_no: (pageNo || currentPage) - 1,
      branch_id: JSON.parse(localStorage.getItem("inventory"))?.userData
        ?.branch_data?.[0]?.branch_id,
    };
    if (isFilter) {
      // if (dates) {
      //   formInputs.from_date = dates[0];
      //   formInputs.to_date = dates[1];
      // }
      json = {
        ...json,
        ...formInputs,
        branch_id:
          JSON.parse(localStorage.getItem("inventory"))?.userData
            ?.branch_data?.[0]?.branch_id || formInputs.branch_id,
      };
    }
    await $.post(
      `${config.apiUrl}/purchaseOrderReturn/listPurchaseOrderReturn`,
      JSON.stringify(json),
    )
      .done(function (res) {
        setCurrentPage(pageNo || currentPage);
        setIsSubmit(false);
        setList(res.data?.list);
        setIsLoading(false);
        setTotalPage(res?.data?.count);
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.responseJSON?.data?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  const [exportIds, setExportIds] = useState([]);
  const [isExport, setIsExport] = useState(false);
  const getExportIds = (e) => {
    if (e.target.value === "All") {
      if (e.target.checked) {
        setExportIds((prevState) => [
          ...prevState,
          ...list.map((v) => v.po_rtn_id),
        ]);
      } else {
        setExportIds(() => []);
      }
    } else {
      const val = e.target.value;
      if (e.target.checked) {
        setExportIds((prevState) => [
          ...prevState,
          val.match(/^\d+$/) ? Number(val) : val,
        ]);
      } else {
        setExportIds((prevState) => prevState.filter((v) => v != val));
      }
    }
  };

  const downloadExportJson = async () => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Purchase Return");
      return;
    }
    let branch_id =
      JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]
        ?.branch_id || formInputs.branch_id;
    setIsExport(true);
    await $.post(
      `${config.apiUrl}/purchaseOrderReturn/exportPurchaseReturn`,
      JSON.stringify({
        purchase_order_return_ids: exportIds,
        branch_id: branch_id,
      }),
    )
      .done(function (res) {
        const jsonData = new Blob([JSON.stringify(res, null, 3)], {
          type: "text/json",
        });
        const jsonURL = window.URL.createObjectURL(jsonData);
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = jsonURL;
        link.setAttribute("download", "Purchase-Return.json");
        link.click();
        document.body.removeChild(link);
        setIsExport(false);
        getList(filterActive);
      })
      .catch(function (err) {
        setIsExport(false);
        Swal.fire(
          "Error",
          err?.responseJSON?.data?.message || err?.responseJSON?.message,
        );
      });
  };

  const sendERP = async (type = "ERP") => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Purchase Return");
      return;
    }

    const selectedItems = list.filter((x) => exportIds.includes(x.po_rtn_id));
    const alreadySynced = selectedItems.filter((x) => x.sync_status == 1);

    if (alreadySynced.length > 0) {
      const nos = alreadySynced.map((x) => x.po_rtn_no || x.po_no).join(", ");
      Swal.fire({
        icon: "warning",
        title: "Already synced",
        text: `Purchase Return no ${nos} are already synced successfully. Please untick them first and then Send to ERP.`,
        confirmButtonText: "OK",
      });
      return;
    }

    setIsErpLoading(true);
    await $.post(
      `${config.apiUrl}/purchaseOrderReturn/updateErpStatus`,
      JSON.stringify({
        po_rtn_ids: exportIds,
        is_erp: 1,
        type: type,
      }),
    )
      .done(function (res) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            res?.data?.message ||
            (type === "NON-ERP"
              ? "Purchase Return successfully marked for Non ERP."
              : "Purchase Return successfully sent to ERP."),
        });
        getList(filterActive);
      })
      .catch(function (err) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            err?.responseJSON?.data?.message ||
            err?.responseJSON?.message ||
            "Something went wrong while sending to ERP",
        });
      });
  };

  useEffect(
    function () {
      getList(filterActive);
    },
    [currentPage],
  );

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-1">
          <Header />

          <main className="bg-white rounded-4" id="pur_rtn">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Purchase Return"]} />
                </div>
                <div className="col text-end">
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>
                  {user.role_id !== 2 ? (
                    <Link
                      to="/purchase-return/add"
                      className="btn btn-primary px-4 py-2"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        float: "right",
                      }}
                    >
                      New Purchase Return
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    setFilterActive(true);

                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  id="pur_rtnAdd"
                  className="card border-0 shadow-sm p-3 my-3"
                  autoComplete="off"
                >
                  <div className="row g-3 mb-2">
                    <div className="col-md-3">
                      <label htmlFor="buyer_name">Supplier Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="buyer_name"
                        value={formInputs.buyer_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="po_no">Purchase No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="po_no"
                        value={formInputs.po_no}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="po_rtn_no">Purchase Return No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="po_rtn_no"
                        value={formInputs.po_rtn_no}
                        onChange={handleInputs}
                      />
                    </div>
                    {user.role_id != 3 && user.role_id != 4 && (
                      <div className="col-md-3">
                        <label htmlFor="branch_id">Branch</label>
                        <select
                          className="form-select"
                          id="branch_id"
                          name="branch_id"
                          value={formInputs.branch_id}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              branch_id: e.target.value,
                            })
                          }
                        >
                          <option value={""}>select...</option>
                          {props.branchList.map((v, i) => (
                            <option key={i} value={v.value}>
                              {v.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                  <div className="row g-3 mb-2">
                    <div className="col-md-2">
                      <label htmlFor="status">Status</label>
                      <select
                        className="form-select"
                        id="is_active"
                        name="is_active"
                        value={formInputs.is_active}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_active: e.target.value,
                          })
                        }
                      >
                        {/* <option hidden>Please Select</option> */}
                        {[
                          { id: "", name: "All" },
                          { id: 2, name: "Approved" },
                          { id: 4, name: "Partial Done" },
                          {
                            id: 1,
                            name: "Pending",
                          },
                          {
                            id: 3,
                            name: "Rejected",
                          },
                        ].map((v, i) => (
                          <option
                            key={i}
                            value={v.id}
                            // className={v.id === 0 ? "bg-lightgrey" : ""}
                          >
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {erpIntegration == 1 ? (
                      <div className="col-md-2">
                        <label htmlFor="sync_status">Sync Status</label>
                        <select
                          className="form-select"
                          id="sync_status"
                          name="sync_status"
                          value={formInputs.sync_status}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              sync_status: e.target.value,
                            })
                          }
                        >
                          {[
                            { id: "", name: "All" },
                            { id: 0, name: "Pending" },
                            { id: 1, name: "Success" },
                            { id: 2, name: "Failed" },
                          ].map((v, i) => (
                            <option
                              key={i}
                              value={v.id}
                              className={v.id === 0 ? "bg-lightgrey" : ""}
                            >
                              {v.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                    {/* <DateRangeFilter
                      filterDate={filterDate}
                      onChange={handleInputDate}
                    /> */}
                    <div className="col-md-2">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="from_date"
                        value={formInputs.from_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="to_date"
                        value={formInputs.to_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                  </div>
                  <div className="row g-2 mt-1">
                    <div className="col-12 d-flex gap-2">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "36px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minWidth: "90px",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-outline-secondary rounded-3 px-3 text-dark"
                        type="reset"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          setFilterDate();
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          fontSize: "14px",
                          height: "36px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minWidth: "110px",
                        }}
                      >
                        Clear Filters
                      </button>
                      {/* <button
                        className="btn btn-primary py-0 text-white"
                        type="button"
                        onClick={downloadExportJson}
                        style={{
                          background: "#4263eb",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "36px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minWidth: "80px",
                        }}
                      >
                        {isExport && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Export
                      </button> */}
                      {erpIntegration == 1 ? (
                        <div className="btn-group ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                              background: "#4263eb",
                              borderColor: "#4263eb",
                              borderTopLeftRadius: "8px",
                              borderBottomLeftRadius: "8px",
                              fontWeight: "600",
                              fontSize: "14px",
                              height: "35px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#ffffff",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => sendERP("ERP")}
                            disabled={isErpLoading}
                          >
                            {isErpLoading && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            Mark For ERP
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={isErpLoading}
                            style={{
                              background: "#3b5bdb",
                              borderColor: "#3b5bdb",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              height: "35px",
                              color: "#ffffff",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            <span className="visually-hidden">Toggle Dropdown</span>
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end shadow"
                            style={{ minWidth: "160px", zIndex: 1050 }}
                          >
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("ERP")}
                              >
                                Mark For ERP
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("NON-ERP")}
                              >
                                Mark For Non ERP
                              </button>
                            </li>
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </form>
              )}

              {(error || success) && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-${
                        error ? "danger" : "success"
                      } py-1 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table
                    className={`table ${
                      error || success ? "my-1" : "mt-4"
                    } rounded`}
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            id="All"
                            value="All"
                            onChange={(e) => getExportIds(e)}
                          />
                        </th>
                        <th>Purchase Return No</th>
                        <th>Purchase No</th>
                        <th>Supplier Name</th>
                        <th>Reason</th>
                        {user.role_id != 3 && user.role_id != 4 && (
                          <th>Branch Name</th>
                        )}
                        <th className="text-end">Amount</th>
                        <th>Date</th>
                        <th>Status</th>
                        {erpIntegration == 1 ? <th>Sync Status</th> : null}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length == 0) && (
                        <tr>
                          <td colSpan={erpIntegration == 1 ? (user.role_id != 3 && user.role_id != 4 ? "11" : "10") : (user.role_id != 3 && user.role_id != 4 ? "10" : "9")} className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list?.map((v, i) => (
                        <>
                          <tr
                            key={`pl_` + i}
                            className={v.is_active ? "" : "bg-lightgrey"}
                            // style={
                            //   v?.export_count > 0
                            //     ? {
                            //         backgroundColor: `rgba(13, 202, 240, ${Math.min(
                            //           v?.export_count * 0.15,
                            //           1,
                            //         )})`,
                            //       }
                            //     : {}
                            // }
                          >
                            <td>
                              <input
                                type="checkbox"
                                value={v?.po_rtn_id}
                                checked={exportIds.includes(v?.po_rtn_id)}
                                onChange={(e) => getExportIds(e)}
                              />
                            </td>
                            {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                            <td>
                              <span
                                className="link-primary user-select-none"
                                role="button"
                                onClick={() => toggleItemDetail(`pli_${i}`)}
                              >
                                {v.po_rtn_no}
                              </span>
                            </td>
                            <td>{v.po_no}</td>
                            <td>
                              {
                                props?.buyerLists?.find(
                                  (el) => el?.value === v.buyer_id,
                                )?.label
                              }
                            </td>
                            <td>
                              <span title={v.reason}>
                                {v.reason && v.reason.length > 15
                                  ? v.reason.toString().substring(0, 15) + "..."
                                  : v.reason}
                              </span>
                            </td>
                            {user.role_id != 3 && user.role_id != 4 && (
                              <td>{v?.mst_branch?.branch_name}</td>
                            )}
                            <td className="text-end">
                              {/* {v.total_amt.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })} */}
                              {millionComma(v.total_amt)}
                            </td>
                            <td>
                              {Moment(v.trans_date, "YYYY-MM-DD").format(
                                "DD-MM-YY",
                              )}
                            </td>
                            {/* <td className="text-end">
                              {v?.export_count || "0"}
                            </td> */}

                            <td className="">{formatStatusBadge(v)}</td>
                            {erpIntegration == 1 && (
                              <td>
                                {v.is_erp == 1
                                  ? (() => {
                                    const status = v?.sync_status;

                                    if (status === 0) {
                                      return (
                                        <span
                                          className="badge bg-warning"
                                          style={{ fontSize: "11px" }}
                                        >
                                          Pending
                                        </span>
                                      );
                                    }

                                    if (status === 1) {
                                      return (
                                        <span
                                          className="badge bg-success"
                                          style={{ fontSize: "11px" }}
                                        >
                                          Success
                                        </span>
                                      );
                                    }

                                    if (status === 2) {
                                      return (
                                        <>
                                          <span
                                            className="badge bg-danger"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Failed
                                          </span>

                                          <Tippy
                                            content={
                                              v?.sync_err || "Sync Error"
                                            }
                                          >
                                            <span
                                              style={{ cursor: "pointer" }}
                                            >
                                              <FaInfoCircle
                                                style={{
                                                  fontSize: "15px",
                                                  marginLeft: "5px",
                                                }}
                                              />
                                            </span>
                                          </Tippy>
                                        </>
                                      );
                                    }

                                    return (
                                      <span className="text-muted">-</span>
                                    );
                                  })()
                                  : "NA"}
                              </td>
                            )}
                            <td className="edit">
                              <Tippy content="View">
                                <Link
                                  to={`/purchase-return/view/` + v.po_rtn_id}
                                  state={{
                                    purchaseRtn: v,
                                    currentPageNo: currentPage,
                                    currentFilter: formInputs,
                                    showFilter: filtersVisible,
                                  }}
                                  className={`link-info m-1`}
                                >
                                  <img
                                    src={viewIcon}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </Link>
                              </Tippy>

                              {(user?.role_id === 3 || user?.role_id === 4) && (
                                <>
                                  {(v.is_active == 3 || v.is_active == 4) && (
                                    <Tippy content="Edit">
                                      <Link
                                        to={
                                          `/purchase-return/edit/` + v.po_rtn_id
                                        }
                                        state={{
                                          purchaseRtn: v,
                                          currentPageNo: currentPage,
                                          currentFilter: formInputs,
                                          showFilter: filtersVisible,
                                        }}
                                        className={`link-info m-1`}
                                      >
                                        <img
                                          src={editIcon}
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </Link>
                                    </Tippy>
                                  )}
                                </>
                              )}
                              {loginBranch?.auto_approve &&
                                loginBranch?.branch_id === v.branch_id &&
                                (v.is_active === 1 || v.is_active === true) && (
                                  <Tippy content="Approve">
                                    <a
                                      href="#cancel"
                                      onClick={(e) =>
                                        ApprovedBranch(v.po_rtn_id)
                                      }
                                      className="link-info"
                                    >
                                      <FcApproval size={24} />
                                    </a>
                                  </Tippy>
                                )}
                              {/*{user.role_id !== 2 ? (
                                                            <Tippy content="Cancel">
                                                                <a
                                                                    href="#cancel"
                                                                    onClick={(e) =>
                                                                        changeStatus(v.po_rtn_id, v.branch_id)
                                                                    }
                                                                    className={`link-info m-1 ${
                                                                        v.is_active ? "" : "d-none"
                                                                    }`}
                                                                >
                                                                    <img
                                                                        src={deleteIcon}
                                                                        className="img-fluid"
                                                                        alt=""
                                                                    />
                                                                </a>
                                                            </Tippy>
                                                        ) : (
                                                            ""
                                                        )}*/}
                            </td>
                          </tr>
                          <tr
                            key={`pli_` + i}
                            id={`pli_` + i}
                            className="d-none"
                          >
                            <td colSpan="8">
                              <div className="table-responsive">
                                <table className="table table-sm table-bordered ms-auto w-50 py-0 mb-0">
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>Item Name</th>
                                      <th>Qty</th>
                                      <th>Rate</th>
                                      <th>Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {v.item_dtl &&
                                      v?.item_dtl?.map((v, i) => (
                                        <tr key={`plil_` + i}>
                                          <td>{i + 1}</td>
                                          <td>
                                            {
                                              props?.itemLists?.find(
                                                (el) =>
                                                  el?.value === v?.item_id,
                                              )?.label
                                            }
                                          </td>
                                          <td className="text-end">
                                            {parseFloat(v.qty).toFixed(2)}
                                          </td>
                                          <td className="text-end">
                                            {millionComma(v?.rate)}
                                          </td>
                                          <td className="text-end">
                                            {millionComma(v?.amount)}
                                          </td>
                                        </tr>
                                      ))}
                                    <tr>
                                      <td
                                        colSpan="4"
                                        className="text-end pe-2 fw-bold"
                                      >
                                        Gross Total
                                      </td>
                                      <td className="fw-bold text-end">
                                        {millionComma(v.total_amt)}

                                        {/* {parseFloat(v?.total_amt).toFixed(4)} */}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default PurchaseReturnList;
